var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { merge } from 'lodash';
import NotImplemented from '../NotImplemented';
import TrimPackages from './TrimPackages';
import getModelPePricing from '../../utils/getModelPePricing';
import getTrimWithInteriorColorPricing from '../../utils/getTrimWithInteriorColorPricing';
import useAppName from '../../utils/sitecoreContext/useAppName';
import { ACURA_SITE_NAME, HONDA_SITE_NAME, PE_SITE_NAME, PSP_SITE_NAME } from '../../utils/constants';
import { PAYMENT_FREQUENCY, PAYMENT_METHOD, variant1, variant2, variant3 } from './service/constants';
import { getTrimPricing } from '../../utils/trimUtils';
import { isEmpty } from '../../utils/object';
import { mapPEFields, mapPSPFields } from './utils';
var TrimPackagesMap = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
    var propVariant = _a.variant, fields = _a.fields, rendering = _a.rendering, rest = __rest(_a, ["variant", "fields", "rendering"]);
    var appName = useAppName();
    if (!fields || isEmpty(fields) || !((_b = fields === null || fields === void 0 ? void 0 : fields.data) === null || _b === void 0 ? void 0 : _b.value)) {
        return null;
    }
    var cardBackgroundHoverColor = 'secondary';
    var cardCtaButtonHoverColor = 'secondary';
    var cardCtaButtonStyle = 'secondary';
    var mappedFields = fields || {};
    var packageSelectorContainerStylesTop = ['70px', '70px', '84px'];
    var paymentOptions = {};
    var shouldFetchInventory = false;
    var isRebatesDisclaimer = false;
    var shouldFetchPayment = true;
    var shouldPushGtmCarouselNavigation = true;
    var showAddToCompareButton;
    var trimCardStylesStyledBoxPaddingX = ['default', 's'];
    var trimCardStylesStyledBoxPaddingTop = ['default', 's'];
    var trimCardStylesStyledBoxPaddingBottom = ['default', 's'];
    var trimPricingFormatter = getTrimWithInteriorColorPricing;
    var variant;
    var vehicleType;
    var categoryName;
    var usesModelName = false;
    switch (appName) {
        case ACURA_SITE_NAME:
            variant = variant1;
            paymentOptions = {
                paymentMethod: (_f = (_e = (_d = (_c = fields === null || fields === void 0 ? void 0 : fields.data) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.paymentMethod) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.toLowerCase(),
                paymentFrequency: ((_k = (_j = (_h = (_g = fields === null || fields === void 0 ? void 0 : fields.data) === null || _g === void 0 ? void 0 : _g.value) === null || _h === void 0 ? void 0 : _h.paymentFrequency) === null || _j === void 0 ? void 0 : _j.value) === null || _k === void 0 ? void 0 : _k.toLowerCase()) || 'weekly',
            };
            packageSelectorContainerStylesTop = '70px';
            cardBackgroundHoverColor = 'black';
            break;
        case HONDA_SITE_NAME:
            variant = variant1;
            paymentOptions = {
                paymentMethod: (_p = (_o = (_m = (_l = fields === null || fields === void 0 ? void 0 : fields.data) === null || _l === void 0 ? void 0 : _l.value) === null || _m === void 0 ? void 0 : _m.paymentMethod) === null || _o === void 0 ? void 0 : _o.value) === null || _p === void 0 ? void 0 : _p.toLowerCase(),
                paymentFrequency: ((_t = (_s = (_r = (_q = fields === null || fields === void 0 ? void 0 : fields.data) === null || _q === void 0 ? void 0 : _q.value) === null || _r === void 0 ? void 0 : _r.paymentFrequency) === null || _s === void 0 ? void 0 : _s.value) === null || _t === void 0 ? void 0 : _t.toLowerCase()) || 'weekly',
            };
            break;
        case PE_SITE_NAME:
            variant = variant3;
            // TODO: typing to be fixed
            // @ts-ignore
            mappedFields = mapPEFields(mappedFields);
            categoryName = (_z = (_y = (_x = (_w = (_v = (_u = fields === null || fields === void 0 ? void 0 : fields.data) === null || _u === void 0 ? void 0 : _u.value) === null || _v === void 0 ? void 0 : _v.subCategory) === null || _w === void 0 ? void 0 : _w.fields) === null || _x === void 0 ? void 0 : _x.category) === null || _y === void 0 ? void 0 : _y.name) !== null && _z !== void 0 ? _z : '';
            paymentOptions = {
                paymentMethod: PAYMENT_METHOD, // by default for pe || 'finance'
                paymentFrequency: PAYMENT_FREQUENCY, // by default for pe || 'weekly'
            };
            cardBackgroundHoverColor = 'grey.5';
            cardCtaButtonHoverColor = 'black';
            trimCardStylesStyledBoxPaddingTop = ['default', 'default', 'default'];
            trimCardStylesStyledBoxPaddingBottom = ['default', 'default', '0'];
            trimCardStylesStyledBoxPaddingX = ['20px', 'default', 'default'];
            shouldFetchInventory = true;
            shouldFetchPayment = false;
            packageSelectorContainerStylesTop = ['70px', '70px', '75px'];
            isRebatesDisclaimer = true;
            // @ts-ignore
            trimPricingFormatter = getModelPePricing;
            usesModelName = true;
            break;
        case PSP_SITE_NAME:
            variant = variant2;
            mappedFields = mapPSPFields(mappedFields);
            vehicleType = (_5 = (_4 = (_3 = (_2 = (_1 = (_0 = mappedFields === null || mappedFields === void 0 ? void 0 : mappedFields.data) === null || _0 === void 0 ? void 0 : _0.value) === null || _1 === void 0 ? void 0 : _1.modelYear) === null || _2 === void 0 ? void 0 : _2.fields) === null || _3 === void 0 ? void 0 : _3.category) === null || _4 === void 0 ? void 0 : _4.vehicleType) === null || _5 === void 0 ? void 0 : _5.name;
            paymentOptions = {
                paymentMethod: PAYMENT_METHOD, // by default for psp || 'finance'
                paymentFrequency: PAYMENT_FREQUENCY, // by default for psp || 'weekly'
            };
            packageSelectorContainerStylesTop = ['70px', '70px', '75px'];
            shouldPushGtmCarouselNavigation = false;
            // TODO: improve this deadline hotfix + temporary bandaid solution
            // eslint-disable-next-line no-param-reassign, @typescript-eslint/no-explicit-any
            rest.priceStyles = merge((_6 = rest.priceStyles) !== null && _6 !== void 0 ? _6 : {}, {
                priceStyles: {
                    disclaimer: {
                        styles: {
                            textAlign: 'center',
                        },
                    },
                },
            });
            // @ts-ignore
            trimPricingFormatter = getTrimPricing;
            break;
        default:
            return React.createElement(NotImplemented, { name: "TrimPackages" });
    }
    return (React.createElement(TrimPackages, { appNameConfig: __assign(__assign({}, rest), { cardBackgroundHoverColor: cardBackgroundHoverColor, cardCtaButtonHoverColor: cardCtaButtonHoverColor, cardCtaButtonStyle: cardCtaButtonStyle, packageSelectorContainerStylesTop: packageSelectorContainerStylesTop, paymentOptions: paymentOptions, shouldFetchInventory: shouldFetchInventory, isRebatesDisclaimer: isRebatesDisclaimer, shouldFetchPayment: shouldFetchPayment, shouldPushGtmCarouselNavigation: shouldPushGtmCarouselNavigation, showAddToCompareButton: showAddToCompareButton, usesModelName: usesModelName, trimCardStyles: {
                styledBox: {
                    paddingTop: trimCardStylesStyledBoxPaddingTop,
                    paddingBottom: trimCardStylesStyledBoxPaddingBottom,
                    paddingX: trimCardStylesStyledBoxPaddingX,
                },
            }, trimPricingFormatter: trimPricingFormatter }), componentName: rendering === null || rendering === void 0 ? void 0 : rendering.componentName, fields: mappedFields, paymentOptions: paymentOptions, variant: propVariant !== null && propVariant !== void 0 ? propVariant : variant, vehicleType: vehicleType, categoryName: categoryName }));
};
export default TrimPackagesMap;
